<template>
  <f-modal
    ref="note-popup-modal"
    :class="{ 'is-visible': isVisible }"
    @close="handleClose">
    <f-modal-header>
      <h3 class="heading-medium">
        <template v-if="editMode">
          {{ $t('notesList.editNotes') }}
        </template>
        <template v-else>
          {{ $t('notesList.newNotes') }}
        </template>
      </h3>
    </f-modal-header>

    <f-modal-body>
      <validation-observer
        ref="note-popup-form"
        tag="form">

        <div class="form-group">
          <label for="note">{{ $t('notesList.contentOfNote') }}</label>

          <validation-provider
            rules="required"
            name="note"
            v-slot="{ errors }">
            <f-textarea
              v-model="data.note"
              :rows="6"
              :state="errors.length ? 'invalid' : null"/>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>

        <div>
          <f-file-input
            class="mt-3"
            id="noteFiles"
            label="Dodaj załącznik"
            icon="attachment"
            accept=".pdf, .jpg, .jpeg, .png, .gif, .doc, .docx, .xls, .xlsx"
            :multiple="true"
            :onChange="attachFiles"/>
        </div>

        <div
        v-if="data.files.length"
        class="flex flex-column full-width files-list">
        <div
          v-for="(item, index) of data.files"
          :key="index"
          :class="{
            'flex flex-column full-width': true,
            'mt-4': index !== 0
          }">
          <label>{{ $t('messageForm.fileName') }}</label>
          <span class="mr-3 mb-2">
            <template v-if="item.preexisting">
              {{ item.file }}
            </template>
            <template v-else>
              {{ item.file.name }}
            </template>
          </span>
          <div class="text-right">
            <f-button
              v-if="item.preexisting"
              theme="dark"
              class="ml-2 mb-1"
              :disabled="actionInProgress"
              @click.prevent="downloadFile(index)">
              {{ $t('messageForm.downloadFile') }}
            </f-button>
            <f-button
              class="ml-2 mb-1"
              theme="danger"
              :disabled="actionInProgress"
              @click.prevent="removeFile(index)">
              {{ $t('messageForm.deleteFile') }}
            </f-button>
          </div>
        </div>
      </div>

      </validation-observer>

    </f-modal-body>
    <f-modal-footer>
      <div class="flex flex-justify-content-between">
        <f-button
          class="ml-0"
          theme="danger"
          @click.prevent="handleClose">
          {{ $t('ui.cancel') }}
        </f-button>
        <f-button
          class="ml-auto"
          theme="primary"
          :disabled="submitInProgress"
          @click.prevent="validateForm">
          <div
            v-if="submitInProgress"
            class="loading-spinner"
            role="status">
          </div>
          <template v-if="editMode">{{ $t('ui.saveChange') }}</template>
          <template v-else>{{ $t('ui.add') }}</template>
        </f-button>
      </div>
    </f-modal-footer>
  </f-modal>
</template>
<script>

import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import ListUtils from '@/utils/ListUtils.js';

export default {
  name: 'note-popup',
  computed: {
  },
  data() {
    return {
      data: {
        id: 0,
        adviser_customer_id: 0,
        note: '',
        files: []
      },
      editMode: false,
      isHidden: true,
      submitInProgress: false,
      isVisible: false,
      actionInProgress: false
    };
  },
  mounted() {
    this.$bus.$on('note-popup-show', this.openPopup);
  },
  methods: {
    handleClose() {
      document.body.classList.remove('no-scroll');
      this.isVisible = false;
    },
    openPopup(adviserCustomerId, note = null) {
      this.editMode = note !== null;

      if (this.editMode) {
        this.data.id = note.id;
        this.data.adviser_customer_id = note.adviser_customer_id;
        this.data.note = note.note;
        this.data.files = [];

        for (let i = 0; i < note.files.length; i++) {
          this.data.files.push(note.files[i]);
          this.data.files[i].preexisting = true;
        }
      } else {
        this.data.id = 0;
        this.data.adviser_customer_id = adviserCustomerId;
        this.data.note = '';
        this.data.files = [];
      }

      setTimeout(() => {
        this.isVisible = true;
        this.submitInProgress = false;
        document.body.classList.add('no-scroll');
        if (this.$refs['note-popup-form']) {
          this.$refs['note-popup-form'].reset();
        }
      }, 0);
    },
    validateForm () {
      FormUtils.validate(this.$refs['note-popup-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.editMode ? '/api/adviser/customers/notes/update/' + this.data.id : '/api/adviser/customers/notes/store';

      let fileParams = [];
      if (formDataToSend.files.length) {
        fileParams.push('files');
      }

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('notesList.noteSaved'),
        successText: this.$t('notesList.selectedNoteWasRecorded'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('notesList.modifyNoteError'),
        successAction: () => {
          this.$bus.$emit('notes-list-reload');
          this.handleClose();
        }
      }, fileParams);
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        adviser_customer_id: this.data.adviser_customer_id,
        note: this.data.note
      };

      formDataToSend.files = [];

      for (let i = 0; i < this.data.files.length; i++) {
        if (!('preexisting' in this.data.files[i])) {
          formDataToSend.files.push(this.data.files[i].file);
        }
      }

      return formDataToSend;
    },
    attachFiles (event) {
      this.data.files.push({ file: event.target.files[0] });
    },
    removeFile (index) {
      if (!this.data.files[index].preexisting) {
        this.data.files.splice(index, 1);

        return;
      }

      this.actionInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: 'api/adviser/customers/notes/files/delete/',
        id: this.data.files[index].id,
        successTitle: this.$t('inquiryFiles.removeFile'),
        successText: this.$t('inquiryFiles.selectedFileRemove'),
        confirmTitle: this.$t('inquiryFiles.areYouSureSelectedFileRemove'),
        confirmText: this.$t('ui.thisOperationCannotUndone'),
        confirmButtonText: this.$t('ui.yesRemove'),
        errorText: this.$t('inquiryFiles.removeFileError'),
        successAction: () => {
          this.actionInProgress = false;
          this.data.files.splice(index, 1);
        },
        cancelAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    downloadFile (index) {
      this.actionInProgress = true;
      let endpointUrl = '/api/adviser/customers/notes/files/download/' + this.data.files[index].id;

      this.$http.get(endpointUrl, {
        responseType: 'blob',
      }).then(response => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.data.files[index].file);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.actionInProgress = false;
        } else {
          Vue.swal({
            title: this.$t('inquiryFiles.downloadFileError'),
            html: this.$t('ui.tryAgain'),
            icon: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
          this.actionInProgress = false;
        }
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('inquiryFiles.downloadFileError'),
          html: this.$t('ui.tryAgain'),
          icon: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.actionInProgress = false;
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('note-popup-show', this.openPopup);
  }
}
</script>
